module.exports = __webpack_public_path__ + "collection-sets-square.png?0162234945b2b9e02b59f03c03538004";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/collection-sets-square.png
// module id = 219
// module chunks = 0